import styled from 'styled-components'

import { ButtonEditUnstyled } from 'Components/Buttons/ButtonEdit/unstyled'

export const ButtonEdit = styled(ButtonEditUnstyled)`
  display: block;
  width: 44px;
  height: 44px;
  position: relative;
  background: ${props => props.theme.colors.regentGray};
  border-radius: 4px;
  float: ${props => props.float};
  cursor: pointer;

  svg {
    position: absolute;
    height: 100%;
    width: 14px;
    fill: ${props => props.theme.colors.white};
    left: 0;
    right: 0;
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonEdit/index.js